<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="printerModules"
        :table-select="false"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @reset="resetHandle">
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
            <el-form-item label="编号">
              <el-input v-model.trim="filter.no" placeholder="请输入组件编号" clearable/>
            </el-form-item>
            <el-form-item label="名称">
              <el-input v-model.trim="filter.name" placeholder="请输入组件名称" clearable/>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="filter.status" placeholder="请选择状态" clearable>
                <el-option label="在用" :value="0"/>
                <el-option label="报废" :value="1"/>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </view-table>
    <printer-component-manage-edit ref="printerComponentManageEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import PrinterComponentManageEdit from "./PrinterComponentManageEdit.vue";

  export default {
    name: "PrinterComponentManage",
    components: { ViewTable, PrinterComponentManageEdit },
    data() {
      return {
        limits: {
          addAuth: this.$auth(84),
          editAuth: this.$auth(84),
          delAuth: this.$auth(85),
        },
        filter: {
          no: "",
          name: "",
          status: "",
        },
        columnsProperty: [
          {
            tooltip: true,
            key: "no",
            align: "center",
            width: 160,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.printerComponentManageEdit.open(params.row, true);
                    },
                  },
                },
                params.row.no
              );
            },
          },
          {
            tooltip: true,
            key: "name",
            minWidth: 300,
          },
          {
            tooltip: true,
            key: "status",
            width: 160,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: params.row.status === 0 ? "#67c23a" : "#909399",
                  },
                },
                params.row.status === 0 ? "在用" : "报废"
              );
            },
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
      addEditHandle(row) {
        this.$refs.printerComponentManageEdit.open(row);
      },
      deleteHandle(row) {
        this.$http.delete("basic", "printerModules", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
    },
  };
</script>
